import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators, ReactiveFormsModule } from '@angular/forms';
import { StaffProductLimit, TimePeriod } from 'src/app/api/api-campaigns.service.generated';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TimePeriodSelectComponent } from '../time-period-select/time-period-select.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
    selector: 'app-staff-product-limit',
    templateUrl: './staff-product-limit.component.html',
    styleUrls: ['./staff-product-limit.component.scss'],

    imports: [
        ReactiveFormsModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        MatDatepickerModule,
        TimePeriodSelectComponent
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StaffProductLimitComponent),
            multi: true
        }],

})
export class StaffProductLimitComponent implements ControlValueAccessor {

  grp = new FormGroup({
    isPercent: new FormControl(),
    period: new FormControl(),
    maxValue: new FormControl(null, Validators.required),
    maxPercent: new FormControl(null, Validators.required),
    baseDate: new FormControl(null, Validators.required)
  });

  constructor() {
    this.grp.valueChanges.subscribe(_ => this.notifyFormChanged());
  }

  /// ControlValueAccessor-------------------
  @Input('value') _value: any;
  onChange: any = () => {};
  onTouched: any = () => {};
  get value(): StaffProductLimit {
    return this._value;
  }
  set value(o: StaffProductLimit) {

    this._value = o;

    this.grp.patchValue(o ? { ...o, isPercent: this.getIsPercent(o) } : {}, { emitEvent: false });

    this.onChange(o);
    this.onTouched();
  }

  getIsPercent(o: StaffProductLimit){
    //== to check null or undefined

    if (o == null)
      return undefined;

    if (o.maxValue == null && o.maxPercent == null)
      return undefined;

    return o.maxPercent != null;
  }


  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(_isDisabled: boolean): void {
  }
  /// ControlValueAccessor------------------

  notifyFormChanged() {
    this._value = this.getFormData();
    this.onChange(this._value);
    this.onTouched();
  }


  getFormData(): StaffProductLimit {
    const f = this.grp.value;

    if (!f.period && (!f.maxValue || !f.maxPercent))
      return undefined;

    return new StaffProductLimit({
      period: this.getTimePeriod(f.period) ,
      baseDate: f.baseDate ? new Date(f.baseDate) : undefined,
      maxValue: !f.isPercent && +f.maxValue > 0 ? +f.maxValue : undefined,
      maxPercent: f.isPercent && +f.maxPercent > 0 ? +f.maxPercent : undefined
    });
  }

  getTimePeriod(period: any) : TimePeriod{
    if (!period)
      return undefined;

    var vPeriod = new TimePeriod();
    vPeriod.init(period);
    return vPeriod;
  }
}
